import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import {
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  map,
  timer,
} from 'rxjs';
import { DiaryTracker } from 'src/app/data/tracker/domain/diary/diary_tracker';

import { DiaryType } from '../../../../data/tracker/domain/diary_type/diary_type';
import { DiaryTypeUtils } from '../../../../data/tracker/domain/diary_type/diary_type_utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-diary-card',
  templateUrl: './diary-card.component.html',
  styleUrls: ['./diary-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DiaryCardComponent implements OnInit {
  @ViewChild('diaryCommentTextarea', { static: false })
  public commentTextarea: ElementRef;
  @Input() type: string | undefined;
  @Input() diaryType: DiaryType | undefined;
  @Input() name: string | undefined;
  @Input() timestamp: Date | undefined;
  @Input() pictures: string[];
  @Input() trackers: DiaryTracker[];
  @Input() comment?: string;
  @Input() isCommentLoading = false;
  @Output() onCommentEdit = new EventEmitter<string>();

  public diaryUtils: DiaryTypeUtils;
  public previewVisible = false;
  public selectedIndex = 0;
  public editedComment: string;
  public showComment = false;

  constructor(private changeDetector: ChangeDetectorRef) {
    // do nothing
  }

  ngOnInit(): void {
    this.diaryUtils = new DiaryTypeUtils();

    this.showComment = !!this.comment;
    if (this.showComment && this.comment) {
      this.editedComment = this.comment;
    }

    timer(0).subscribe(() => {
      if (this.commentTextarea) {
        this.install();
      }
    });
  }

  install() {
    fromEvent(this.commentTextarea.nativeElement, 'keyup')
      .pipe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(1200),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        this.commentEdit();
      });
  }

  showPicture(index: number) {
    this.previewVisible = true;
    this.selectedIndex = index;
  }

  showCommentInput() {
    this.showComment = true;
    this.changeDetector.detectChanges();

    this.install();
  }

  closePreview() {
    this.previewVisible = false;
    this.selectedIndex = 0;
  }

  commentEdit() {
    this.onCommentEdit?.emit(this.editedComment);
    if (this.editedComment?.length <= 0) {
      this.showComment = false;
    }
  }

  get date() {
    return moment(this.timestamp).local().format('HH:mm');
  }
}
